import React from 'react'
import StudentInstruction from '../../Components/StudentInstruction'

export default React.memo(function ASRTeacherModeView(props) {

    const { teacherMode } = props

    if(!teacherMode) return null

    return (
        <StudentInstruction>

        </StudentInstruction>
    )
})